import axios from 'axios'
import store from '../store'
import userCache from './cache'
import {ErrorCode} from './errorcode'
import router from 'PRORouter'

/* 跨域设置 */
axios.interceptors.request.use(
    config => {
        const token = store.state.user.SessionId
        config.headers = {
            'Content-Type': 'application/json',
            'clientType':2
        }
        if (token) {
            config.headers.token = token
        }
        return config
    },
    err => {
        return Promise.reject(err)
    }
)
axios.interceptors.response.use(
    response => {
        if (response.data.errCode == 2) {
            router.push({
                path: '/',
                query: { redirect: router.currentRoute.fullPath }
            })
        }
        return response
    },
    err => {
        return Promise.reject(err.response.data)
    }
)

export function post(url, data = {}) {
    url = this.BILL_URL + url;
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                if(response.data.TypeId == ErrorCode.SessionMissing){
                    userCache.delUser()
                    store.dispatch('DelUser')
                    if(router.currentRoute.path != '/login'){
                        router.push({
                            path: '/login',
                            query: { redirect: router.currentRoute.fullPath,isLose: 2},
                        })
                    }
                }else if(response.data.TypeId == ErrorCode.overTimeMissing){
                    userCache.delUser()
                    store.dispatch('DelUser')
                    if(router.currentRoute.path != '/login'){
                        router.push({
                            path: '/login',
                            query: { redirect: router.currentRoute.fullPath,isLose: 1},
                        })
                    }
                }
                resolve(response.data)
            },
                err => {
                    reject(err)
                }
            )
    }
    )
}
export function postBase(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                if(response.data.TypeId == ErrorCode.SessionMissing){
                    userCache.delUser()                    
                    store.dispatch('DelUser')
                    if(router.currentRoute.path != '/login'){
                        router.push({
                            path: '/login',
                            query: { redirect: router.currentRoute.fullPath ,isLose: 2}
                        })
                    }
                }else if(response.data.TypeId == ErrorCode.overTimeMissing){
                    userCache.delUser()
                    store.dispatch('DelUser')
                    if(router.currentRoute.path != '/login'){
                        router.push({
                            path: '/login',
                            query: { redirect: router.currentRoute.fullPath,isLose: 1},
                        })
                    }
                }
                resolve(response.data)
            },
                err => {
                    reject(err)
                }
            )
    }
    )
}

export function postImage(url, data = {}, config) {
    url = this.BILL_URL + url;
    return new Promise((resolve, reject) => {
        axios.post(url, data, config)
            .then(response => {
                if(response.data.TypeId == ErrorCode.SessionMissing){
                    userCache.delUser()                    
                    store.dispatch('DelUser')
                    
                    if(router.currentRoute.path != '/login'){
                        router.push({
                            path: '/login',
                            query: { redirect: router.currentRoute.fullPath,isLose: 2 }
                        })
                    }
                }else if(response.data.TypeId == ErrorCode.overTimeMissing){
                    userCache.delUser()
                    store.dispatch('DelUser')
                    if(router.currentRoute.path != '/login'){
                        router.push({
                            path: '/login',
                            query: { redirect: router.currentRoute.fullPath,isLose: 1},
                        })
                    }
                }
                resolve(response.data)
            },
                err => {
                    reject(err)
                }
            )
    }
    )
}
export function put(url, data = {}) {
    url = this.BILL_URL + url;
    return new Promise((resolve, reject) => {
        axios.put(url, data)
            .then(response => {
                if(response.data.TypeId == ErrorCode.SessionMissing){
                    userCache.delUser()                    
                    store.dispatch('DelUser')
                    
                    if(router.currentRoute.path != '/login'){
                        router.push({
                            path: '/login',
                            query: { redirect: router.currentRoute.fullPath,isLose: 2 }
                        })
                    }
                }else if(response.data.TypeId == ErrorCode.overTimeMissing){
                    userCache.delUser()
                    store.dispatch('DelUser')
                    if(router.currentRoute.path != '/login'){
                        router.push({
                            path: '/login',
                            query: { redirect: router.currentRoute.fullPath,isLose: 1},
                        })
                    }
                }
                resolve(response.data)
            }, err => {
                reject(err)
            })
    })
}



// WEBPACK FOOTER //
// ./src/util/http.js